<template>
    <vx-card>
        <div class="flex">
            <div class="w-25 mr-6">
                <vs-input class="w-100 mb-base" label="First Name" placeholder="First Name" v-model="UserInfo.first_name"/>
                <vs-input class="w-100 mb-base" label="Last Name" placeholder="Last Name" v-model="UserInfo.last_name"/>
            </div>
            <div class="w-25">
                <vs-input class="w-100 mb-base" label="Email Address" placeholder="Email Address" type="email" v-model="UserInfo.email"/>
                <vs-input class="w-100 mb-base" label="Password" placeholder="Password" type="password" v-model="UserInfo.passwd"/>                
            </div>
            <div>
                <span class="upload_image_span">Choose Photo</span>
                <div class="upload_image">
                    <h3>Upload photo</h3>
                    <button class="btn btn-info">Upload photo</button>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>

export default {
  data() {
    return {
        
    }
  },
   computed: {
    UserInfo () {
      return this.$store.getters['user/GetUserInfo']
    },
      },
  created() {
    // this.$store.dispatch('auth/Auth')
    console.log(this.GetUserInfo)
  },
}
</script>
<style>
    .upload_image{
        width: 250px;
        height: 180px;
        border: 1px dashed black;
        margin-left: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .upload_image_span{
        margin-left: 150px;
    }
</style>